// extracted by mini-css-extract-plugin
export default {"flexBar":"PreconfigErrorDialog_flexBar__10hUE","errorList":"PreconfigErrorDialog_errorList__sZFiH"};